import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import SessionCardContainer from '../containers/SessionCardContainer';
import SelectAreaComponent from '../components/SelectAreaComponent';
import { getUpcomingEvents, refreshSessions } from '../actions/sessionsActions';
import ConditionHelperObj from '../utils/helpers/ConditionHelper';
import i18n from '../utils/i18n';
import { openModal } from '../actions/modalsActions';
import { modals, idsNames } from '../utils/constants';
import { setPendingBookingSessionEventId } from '../actions/pendingBookingActions';
import { resetScrollToId } from '../actions/scrollToActions';
import QuickBookingSessions from '../containers/QuickBookingSessions';
import routeConstants from '../utils/routeConstants';
import { filterConstants } from '../utils/types';
import { getUserData } from '../actions/userActions';
import setFilter from '../actions/filterActions';

import './styles/SessionsScreen.scss';

class Sessions extends React.Component {
  componentDidMount() {
    this.props.refreshSessions();
    this.props.getUserDataFunc();

    if (ConditionHelperObj.userLoggedAndNotSeenWelcomeDialog()) {
      this.props.openModal(modals.WELCOME, {});
    } else if (ConditionHelperObj.userLoggedAndAbleToRateTheApp()) {
      this.props.openModal(modals.APP_RATE, {});
    }
  }

  componentWillUnmount() {
    this.props.setPendingBookingSessionEventId(null);
    this.props.resetScrollToId();
  }

  render() {
    const fetchingEvents = this.props.fetchingUpcomingEvents;
    const upcomingEventsAvailable =
      !fetchingEvents && this.props.upcomingEvents;
    const upcomingEventsEmpty =
      this.props.upcomingEvents && this.props.upcomingEvents.length === 0;
    const availableAreas = this.props.availableAreas || [];

    return (
      <HeaderContainerTemplate>
        <Container className="sessions-screen-wrapper">
          <Row>
            <Col xs={ 12 } md={ 6 } className="sessions-header-column">
              <div className="header2 sessions-cards-title">
                {i18n.t('sessionsScreen.SESSIONS')}
              </div>
            </Col>
            <Col xs={ 12 } md={ 6 } className="select-area-component-wrapper">
              <SelectAreaComponent
                availableAreas={ availableAreas }
                selectedValue={ this.props.areaFilterValue }
                notifyChange={ areaId => {
                  this.props.setAreaFilter(areaId);
                  this.props.getUpcomingEvents(areaId);
                } }
                disabled={ fetchingEvents }
              />
            </Col>
          </Row>
          <Row>
            {fetchingEvents && (
              <div className="sessions-statement">
                {i18n.t('sessionsScreen.FETCHING_SESSIONS')}
              </div>
            )}
            {upcomingEventsAvailable && (
              <div className="sessions-cards-container">
                {this.props.upcomingEvents.map(event => (
                  <div
                    className="session-card-wrapper"
                    id={ idsNames.SESSION_ID_PREFIX + String(event.id) }
                    key={ event.id }
                  >
                    <QuickBookingSessions
                      event={ event }
                      backRoute={ routeConstants.SESSIONS_ROUTE }
                      refreshAction={ refreshSessions() }
                    >
                      <SessionCardContainer event={ event } />
                    </QuickBookingSessions>
                  </div>
                ))}
                {upcomingEventsEmpty && (
                  <div className="no-data-with-criteria">
                    {i18n.t('sessionsScreen.NO_SESSIONS_MATCH_YOUR_CRITERIA')}
                  </div>
                )}
              </div>
            )}
          </Row>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

Sessions.propTypes = {
  getUpcomingEvents: PropTypes.func.isRequired,
  setAreaFilter: PropTypes.func.isRequired,
  fetchingUpcomingEvents: PropTypes.bool,
  upcomingEvents: PropTypes.arrayOf(PropTypes.shape({})),
  openModal: PropTypes.func.isRequired,
  setPendingBookingSessionEventId: PropTypes.func.isRequired,
  availableAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    })
  ),
  areaFilterValue: PropTypes.number,
  refreshSessions: PropTypes.func.isRequired,
  resetScrollToId: PropTypes.func.isRequired,
  getUserDataFunc: PropTypes.func.isRequired
};

Sessions.defaultProps = {
  fetchingUpcomingEvents: false,
  upcomingEvents: [],
  availableAreas: [],
  areaFilterValue: null
};

const mapStateToProps = state => ({
  upcomingEvents: state.upcomingEvents.data,
  fetchingUpcomingEvents: state.upcomingEvents.loading,
  availableAreas: state.venueAreas.data,
  areaFilterValue: state.filter[filterConstants.AREA_FILTER]
});

const mapDispatchToProps = dispatch => ({
  getUpcomingEvents: areaId => dispatch(getUpcomingEvents(areaId)),
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
  setPendingBookingSessionEventId: eventId =>
    dispatch(setPendingBookingSessionEventId(eventId)),
  setAreaFilter: areaId =>
    dispatch(setFilter(filterConstants.AREA_FILTER, areaId)),
  refreshSessions: () => dispatch(refreshSessions()),
  resetScrollToId: () => dispatch(resetScrollToId()),
  getUserDataFunc: () => dispatch(getUserData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sessions);



// WEBPACK FOOTER //
// ./src/scenes/Sessions.js